import { Injectable } from '@angular/core';
import { GraphQLService } from '@core/backend';
import { getTheme, setTheme } from '@core/queries';

@Injectable({
  providedIn: 'root'
})
export class UserThemeService {
  constructor(private graphqlService: GraphQLService) {}

  getTheme() {
    return this.graphqlService.get(getTheme());
  }

  setTheme(theme: string) {
    return this.graphqlService.post(setTheme({ theme }));
  }
}
